"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SvgIcon = _interopRequireDefault(require("./SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SquigleAndTriangle = function SquigleAndTriangle(_ref) {
  var size = _ref.size,
      color = _ref.color,
      secondaryColor = _ref.secondaryColor;
  return _react["default"].createElement(_SvgIcon["default"], {
    title: "squigle-and-triangle",
    size: size
  }, _react["default"].createElement("path", {
    fill: color,
    d: "M3.96 2.39l-.99.4a.75.75 0 00.04 1.4l.93.31-.86.29a.75.75 0 000 1.42l.44.15V7a.5.5 0 001 0v-.82c0-.3-.17-.55-.42-.68l.87-.29a.75.75 0 000-1.42l-1-.33.8-.32a.75.75 0 00.14-1.32l-.89-.59V1a.5.5 0 10-1 0v.37c0 .25.13.48.34.62l.6.4z"
  }), _react["default"].createElement("path", {
    fill: secondaryColor,
    d: "M1.3 3.27L.3 4.6a.25.25 0 00.2.4h2a.25.25 0 00.2-.4l-1-1.33a.25.25 0 00-.4 0z",
    transform: "rotate(90 1.5 4)"
  }));
};

SquigleAndTriangle.defaultProps = {
  size: 8,
  color: '#444',
  secondaryColor: '#444'
};
var _default = SquigleAndTriangle;
exports["default"] = _default;